import React, { Fragment, useEffect } from 'react'
import PropTypes from 'prop-types'

import { axios } from 'api'
import { useModal_deprecated } from 'hooks'

import SurveyOutOfDate from './SurveyOutOfDate'

// A component to let users know that we have updated the survey.
// This was a stop-gap until a better messaging system is developed and deployed.
const AlertModal = ({ data }) => {
  const acknowledgeAlert = async (callback) => {
    try {
      // Dismiss alert (mark as seen and don't show again)
      await axios.post('surveys/onboarding/alerts/dismiss', {
        alert_type: 'out_of_date'
      })
    } catch (error) {
      // Fail silently
      // console.log(error)
    } finally {
      if (callback) callback()
    }
  } 

  const modal = useModal_deprecated(acknowledgeAlert)

  useEffect(() => {
    if (data && data.alerts && data.alerts.outOfDate === true) {
      modal.open()
    }
  }, [data])

  return (
    <Fragment>
      {modal.active && (
        <SurveyOutOfDate useModal={modal} acknowledgeAlert={acknowledgeAlert} />
      )}
    </Fragment>
  )
}

AlertModal.propTypes = {
  data: PropTypes.object
}

export default AlertModal
